/**
 * Design Tokens for the Dropdown
 */
export var buttons = {
  dsPrimary: {
    background: {
      active: 'var(--deprecated-legacy-dsPrimary-background-active)',
      hover: 'var(--deprecated-legacy-dsPrimary-background-hover)',
      idle: 'var(--deprecated-legacy-dsPrimary-background-idle)'
    },
    color: {
      idle: 'var(--deprecated-legacy-dsPrimary-color-idle)'
    }
  },
  dsTransparent: {
    background: {
      active: 'var(--deprecated-legacy-dsTransparent-background-active)',
      hover: 'var(--deprecated-legacy-dsTransparent-background-hover)',
      idle: 'var(--deprecated-legacy-dsTransparent-background-idle)'
    },
    border: {
      active: 'var(--deprecated-legacy-dsTransparent-border-active)',
      idle: 'var(--deprecated-legacy-dsTransparent-border-idle)',
      hover: 'var(--deprecated-legacy-dsTransparent-border-hover)'
    },
    color: {
      idle: 'var(--deprecated-legacy-dsTransparent-color-idle)'
    }
  },
  white: {
    background: {
      active: 'var(--deprecated-legacy-white-background-active)',
      hover: 'var(--deprecated-legacy-white-background-hover)',
      idle: 'var(--deprecated-legacy-white-background-idle)'
    },
    border: {
      active: 'var(--deprecated-legacy-white-border-active)',
      idle: 'var(--deprecated-legacy-white-border-idle)',
      hover: 'var(--deprecated-legacy-white-border-hover)'
    },
    color: {
      idle: 'var(--deprecated-legacy-white-color-idle)'
    }
  },
  transparent: {
    background: {
      active: 'var(--deprecated-legacy-transparent-background-active)',
      hover: 'var(--deprecated-legacy-transparent-background-hover)',
      idle: 'var(--deprecated-legacy-transparent-background-idle)'
    },
    border: {
      active: 'var(--deprecated-legacy-transparent-border-active)',
      idle: 'var(--deprecated-legacy-transparent-border-idle)',
      hover: 'var(--deprecated-legacy-transparent-border-hover)'
    },
    color: {
      idle: 'var(--deprecated-legacy-transparent-color-idle)'
    }
  },
  transparentWhite: {
    background: {
      active: 'var(--deprecated-legacy-transparentWhite-background-active)',
      hover: 'var(--deprecated-legacy-transparentWhite-background-hover)',
      idle: 'var(--deprecated-legacy-transparentWhite-background-idle)'
    },
    border: {
      active: 'var(--deprecated-legacy-transparentWhite-border-active)',
      idle: 'var(--deprecated-legacy-transparentWhite-border-idle)',
      hover: 'var(--deprecated-legacy-transparentWhite-border-hover)'
    },
    color: {
      idle: 'var(--deprecated-legacy-transparentWhite-color-idle)'
    }
  },
  dark: {
    background: {
      active: 'var(--deprecated-legacy-dark-background-active)',
      hover: 'var(--deprecated-legacy-dark-background-hover)',
      idle: 'var(--deprecated-legacy-dark-background-idle)'
    },
    border: {
      active: 'var(--deprecated-legacy-dark-border-active)',
      idle: 'var(--deprecated-legacy-dark-border-idle)',
      hover: 'var(--deprecated-legacy-dark-border-hover)'
    },
    color: {
      idle: 'var(--deprecated-legacy-dark-color-idle)'
    }
  },
  dropdown: {
    background: {
      idle: 'var(--deprecated-legacy-dropdown-background-idle)'
    },
    border: {
      active: 'var(--deprecated-legacy-dropdown-border-active)',
      hover: 'var(--deprecated-legacy-dropdown-border-hover)',
      idle: 'var(--deprecated-legacy-dropdown-border-idle)'
    },
    color: {
      idle: 'var(--deprecated-legacy-dropdown-color-idle)'
    }
  },
  primary: {
    background: {
      active: 'var(--deprecated-legacy-primary-background-active)',
      hover: 'var(--deprecated-legacy-primary-background-hover)',
      idle: 'var(--deprecated-legacy-primary-background-idle)'
    },
    border: {
      active: 'var(--deprecated-legacy-primary-border-active)',
      hover: 'var(--deprecated-legacy-primary-border-hover)',
      idle: 'var(--deprecated-legacy-primary-border-idle)'
    },
    color: {
      idle: 'var(--deprecated-legacy-primary-color-idle)'
    }
  },
  secondary: {
    background: {
      idle: 'var(--deprecated-legacy-secondary-background-idle)'
    },
    border: {
      idle: 'var(--deprecated-legacy-secondary-border-idle)'
    },
    color: {
      idle: 'var(--deprecated-legacy-secondary-color-idle)'
    }
  },
  secondaryBlue: {
    background: {
      active: 'var(--deprecated-legacy-secondaryBlue-background-active)',
      hover: 'var(--deprecated-legacy-secondaryBlue-background-hover)',
      idle: 'var(--deprecated-legacy-secondaryBlue-background-idle)'
    },
    border: {
      idle: 'var(--deprecated-legacy-secondaryBlue-border-idle)'
    },
    color: {
      idle: 'var(--deprecated-legacy-secondaryBlue-color-idle)'
    }
  }
};